import { render, staticRenderFns } from "./NominationEditForm.vue?vue&type=template&id=c891ca98"
import script from "./NominationEditForm.vue?vue&type=script&lang=js"
export * from "./NominationEditForm.vue?vue&type=script&lang=js"
import style0 from "./NominationEditForm.vue?vue&type=style&index=0&id=c891ca98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports